/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyExternalSystem
 */
export interface ReadOnlyExternalSystem {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyExternalSystem
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyExternalSystem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyExternalSystem
     */
    label: string;
}

export function ReadOnlyExternalSystemFromJSON(json: any): ReadOnlyExternalSystem {
    return ReadOnlyExternalSystemFromJSONTyped(json, false);
}

export function ReadOnlyExternalSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyExternalSystem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': json['label'],
    };
}

export function ReadOnlyExternalSystemToJSON(value?: ReadOnlyExternalSystem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
    };
}


